// extracted by mini-css-extract-plugin
module.exports = {"centerChildrenVertically":"OwlPageHeader_centerChildrenVertically__wABqr","owlPageHeader":"OwlPageHeader_owlPageHeader__w4BXi","textContainer":"OwlPageHeader_textContainer__tALpS"};